// Libs
import React, { Component } from 'react';
import qs from 'qs';
import swal from 'sweetalert';
import { connect } from "react-redux";
import * as Fa from 'react-icons/lib/fa';
import { loggedIn } from "../../modules/rootReducers.js";

import Spinner from '../../components/Spinner';
import Alert from '../../components/Alert';
import Auth from '../../services/Auth';
import WS from '../../services/WebSocket';
import User from '../../services/User';
import Settings from '../../services/Settings';

// Assets
import './styles.css';

import Config from '../../config'
import Logger from '../../services/Logger.js';

const AuthService = new Auth();
const UserService = new User();
const WSService = new WS();
const SettingsService = new Settings();
const LoggerService = new Logger();
window.WSService = WSService;

const dispatcher = dispatch => {
  return {
    loggedIn: payload => dispatch(loggedIn(payload))
  }
}

class Login extends Component {

  state = {
    spinner: false,
    loginResult: '',
    loginErrorMessage: '',
    username: '',
    password: '',
    emailAddress: '',
    mode: 'LOGIN',
  }

  componentDidMount() {
    const accessToken = AuthService.getToken()
    if (accessToken && accessToken.length > 0) {
      AuthService.logout()
    };
    document.body.classList.toggle('loginBackground', true);
    if (this.props.location.pathname.indexOf('/login') < 0) {
      this.props.history.push('/login');
    }
  }

  componentWillUnmount = () => {
    document.body.classList.remove('loginBackground');
  }

  toggleLogin = () => {
    this.setState({ spinner: true, loginResult: '' });

    AuthService.login(this.state.username, this.state.password)
      .then((result) => {
        window.store.dispatch(window.actions.loggedIn({ accessToken: result.accessToken, currentUser: result.currentUser }));
        this.setState({ spinner: false }, () => {
          const loadDuration = Math.ceil(window.performance.timing.domComplete - window.performance.timing.navigationStart)
          LoggerService.info("LOGIN/FIRST LOAD", "", loadDuration)
        });
        if (!window.oaWS) {
          WSService.init();
        }
        if (result.currentUser.role === 'ADMIN') {
          UserService.getInvalidEmailUsers()
            .then((result) => {
              if (result.data.length > 0) {
                let message = 'Masih ada alamat email yang mengandung karakter yang tidak valid seperti spasi dan baris baru pada pengguna berikut : ';
                for (let i in result.data) {
                  if (i > 0) message += ', ';
                  message += result.data[i].name
                  if (i > 4) break;
                }
                swal({
                  title: 'Periksa kembali alamat email',
                  text: message,
                  showConfirmButton: true,
                  closeOnConfirm: false
                }, () => {
                  swal.close();

                  // Also check for external letter recipient
                  clearTimeout(this.checkTimeout)
                  this.checkTimeout = setTimeout(() => {
                    if (Config.gerbang) this.checkExternalLetterRecipient()
                  }, 1000)
                })
              } else if (Config.gerbang) this.checkExternalLetterRecipient();
            })
        }
        const parsed = qs.parse(this.props.location.search.replace('?', ''));
        window.browserHistory.push(parsed.redirect ? parsed.redirect : '/');
      })
      .catch((err) => {
        console.log(err);
        var res = JSON.parse(JSON.stringify(err)).response;
        this.setState({ spinner: false });
        if (res) {
          this.setState({ loginResult: res.status });
          this.setState({ loginErrorMessage: res.data });
          return
        }
        this.setState({ loginResult: 0 });
      });
  }

  checkExternalLetterRecipient = () => {
    SettingsService.getSettings()
      .then((settings) => {
        if (settings.externalLetterRecipient === "") {
          swal({
            title: 'Penerima Surat Luar',
            text: "Penerima surat luar belum disetel. Mohon disetel terlebih dahulu agar dapat menerima surat dari instansi lain.",
            showConfirmButton: true,
            confirmButtonText: "Lakukan Penyetelan",
            showCancelButton: true,
            cancelButtonText: "Nanti Saja"
          }, (ok) => {
            if (ok) {
              this.props.history.push('/settings/external_letter_recipient');
            }
          })
        } else {
          swal.close();
        }
      })
  }

  requestPasswordReset = () => {
    this.setState({ spinner: true });
    AuthService.requestPasswordReset(this.state.emailAddress)
      .then((result) => {
        this.setState({ spinner: false, mode: 'LOGIN' });
        swal({
          title: '',
          type: 'warning',
          text: 'Silakan periksa kotak masuk email Anda.',
        });
      })
      .catch((err) => {
        console.log(err);
        var res = JSON.parse(JSON.stringify(err)).response;
        this.setState({ spinner: false });
        if (res) {
          this.setState({ loginResult: res.status });
          this.setState({ loginErrorMessage: res.data });
          return
        }
        this.setState({ loginResult: 0 });
      });
  }

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.toggleLogin();
    }
  }

  render() {
    let loginBody = this.state.spinner ? (<Spinner />) :
      (
        <div >
          {this.state.loginResult === 403 && (this.state.loginErrorMessage === 'unauthenticated' || this.state.loginErrorMessage === 'no rows in result set') && <Alert message='Nama pengguna atau sandi Anda salah.' />}
          {this.state.loginResult === 403 && this.state.loginErrorMessage === 'no-assignment-in-organization' && <Alert message='Pengguna belum dikaitkan ke organisasi.' />}
          {this.state.loginResult === 0 && <Alert message='Galat koneksi : gagal menghubungi peladen.' />}
          {this.state.loginResult >= 500 && <Alert message='Galat pada peladen, silakan menghubungi administrator atau' help="halaman bantuan" />}
          <p className="login-box-msg">Silakan identifikasi diri Anda:</p>
          <div className="form-group has-feedback">
            <input
              onChange={(evt) => { this.setState({ username: evt.target.value }); }}
              name="Username"
              maxLength="50"
              autoComplete="off"
              className="form-control"
              placeholder="Nama pengguna"
              onKeyPress={this.onKeyPress}
            />
            <span className="fa fa-user fa-lg  form-control-feedback" aria-hidden="true"></span>
          </div>
          <div className="form-group has-feedback">
            <input
              onChange={(evt) => { this.setState({ password: evt.target.value }); }}
              name="Password"
              type="password"
              maxLength="255"
              autoComplete="off"
              className="form-control"
              placeholder="Sandi"
              onKeyPress={this.onKeyPress}
            />
            <span className="fa fa-unlock-alt fa-lg form-control-feedback" aria-hidden="true"></span>
          </div>
          <div className="row">
            <div className="col-xs-8 col-md-8">
              <span style={{ cursor: 'pointer' }} onClick={() => { this.setState({ mode: 'FORGOT_PASSWORD' }) }}>Lupa kata sandi?</span>
            </div>
            <div className="col-xs-4 col-md-4">
              <button onClick={() => { this.toggleLogin() }} className="btn btn-primary btn-block btn-flat">Masuk</button>
            </div>
          </div>
        </div>
      );
    let forgotPasswordBody = this.state.spinner ? (<Spinner />) :
      (
        <form onSubmit={this.requestPasswordReset} >
          {this.state.loginResult === 403 && (this.state.loginErrorMessage === 'unauthenticated' || this.state.loginErrorMessage === 'no rows in result set') && <Alert message='Nama pengguna atau sandi Anda salah.' />}
          {this.state.loginResult === 403 && this.state.loginErrorMessage === 'no-assignment-in-organization' && <Alert message='Pengguna belum dikaitkan ke organisasi.' />}
          {this.state.loginResult === 0 && <Alert message='Galat koneksi : gagal menghubungi peladen.' />}
          {this.state.loginResult >= 500 && <Alert message='Galat pada peladen, silakan menghubungi administrator atau' help="halaman bantuan" />}
          <p className="login-box-msg">Silakan identifikasi diri Anda:</p>
          <div className="form-group has-feedback">
            <input
              onChange={(evt) => { this.setState({ emailAddress: evt.target.value }); }}
              name="Alamat email"
              maxLength="50"
              autoComplete="off"
              className="form-control"
              placeholder="Alamat email"
            />
            <span className="fa fa-user fa-lg  form-control-feedback" aria-hidden="true"></span>
          </div>
          <div className="row">
            <div className="col-xs-6 col-md-6">
              <span style={{ cursor: 'pointer' }} onClick={() => { this.setState({ mode: 'LOGIN' }) }}><Fa.FaChevronLeft size={24} color={'grey'} onClick={this.back} style={{ cursor: 'pointer' }} /> Masuk</span>
            </div>
            <div className="col-xs-6 col-md-6">
              <button type="submit" className="btn btn-primary btn-block btn-flat">Reset sandi</button>
            </div>
          </div>
        </form>
      );

    return (
      <div className="login-box">
        <div className="login-box-body">
          <div className="login-logo">
            <a href="/"><img src={Config.variant.images.companyLogo} className="img-responsive center-block" alt="logo" /></a>
          </div>
          {this.state.mode === 'LOGIN' ? loginBody : forgotPasswordBody}
          <div className="login-logo">
            <div className="login-logo-bottom">
              <a href="https://www.baktikominfo.id/" target="_blank" rel="noopener noreferrer"><img src="https://surelintas.id/misc/bakti.png" className="img-responsive center-block bakti-logo" alt="" /></a>
              <a href="https://surelintas.id" target="_blank" rel="noopener noreferrer">
                <img
                  className="center-block surelintas-logo"
                  alt="surelintas"
                  width="80"
                  src="data:image/png;base64,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"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, dispatcher)(Login);
